/**
 * Fetch the recommendations rail.
 *
 * 🔴 IT IS FETCHED RATHER THAN RENDERED WITH THE PAGE because Shopify's recommendations
 * are not available to Liquid on the first render — `recommendations.performed` is false
 * until the `product_recommendations_url` route is asked. This is Shopify's documented
 * shape, not a workaround.
 *
 * ⚠️ ONE REQUEST, NO RETRY, AND SILENCE ON FAILURE. A related-products rail is the least
 * important thing on a product page; a failed fetch removes the placeholder and the page
 * is the page. Retrying would spend a customer's connection on a nicety, and an error
 * message would advertise a feature they never saw.
 */
(function () {
  var host = document.querySelector('[data-djh-recs-mount]');
  if (!host) return;

  var url = host.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
    .then(function (html) {
      // The response is the whole section wrapper; we want what is inside it.
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var rail = doc.querySelector('.djh-recs');
      if (!rail) { host.remove(); return; }
      host.innerHTML = '';
      host.appendChild(rail);
      wire(host);
    })
    .catch(function () { host.remove(); });

  function wire(root) {
    var rail = root.querySelector('[data-djh-recs-rail]');
    var prev = root.querySelector('[data-djh-recs-prev]');
    var next = root.querySelector('[data-djh-recs-next]');
    if (!rail || !prev || !next) return;

    function step() {
      // One card plus its gap, read from the DOM rather than hard-coded — the rail is
      // responsive and a fixed 280 would land mid-card at some widths.
      var first = rail.querySelector('.djh-recs__item');
      return first ? first.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    }

    function refresh() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
      // Nothing to scroll: the arrows are noise, not a disabled control.
      root.querySelector('.djh-recs__nav').hidden = max <= 2;
    }

    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  }
})();
